import React from "react";
import { Link } from "react-router-dom";
import { BookOpenTextIcon, CrownIcon, CalendarCheckIcon, RobotIcon, PlugsConnectedIcon } from "@phosphor-icons/react";

const ONLINE_MS = 6 * 3600 * 1000;

export function isOnline(ts) {
  return ts && Date.now() - new Date(ts).getTime() < ONLINE_MS;
}

export default function DashboardHeader({ me }) {
  const s = me.subscription || {};
  const accounts = me.picks.flatMap((p) => p.accounts);
  const online = accounts.filter((a) => isOnline(a.last_seen)).length;
  const since = me.created_at ? new Date(me.created_at).toLocaleDateString("en-GB", { month: "long", year: "numeric" }) : "-";
  const renew = s.current_period_end ? new Date(s.current_period_end * 1000).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-";
  const tiles = [
    [CrownIcon, "Plan", s.active ? s.tier_name : "No plan yet", "#FBBF24", "dash-tile-plan"],
    [CalendarCheckIcon, s.cancel_at_period_end ? "Ends" : "Renews", s.active ? renew : "-", "#38BDF8", "dash-tile-renewal"],
    [RobotIcon, "Bots picked", `${me.picks.length}${me.pick_limit == null ? "" : ` / ${me.pick_limit}`}`, "#22D3EE", "dash-tile-bots"],
    [PlugsConnectedIcon, "Bots online now", `${online} / ${accounts.length}`, online ? "#34D399" : "#64748B", "dash-tile-online"],
  ];
  return (
    <section data-testid="dashboard-header" className="relative overflow-hidden rounded-2xl border border-[#1E3A8A] p-6 sm:p-8"
      style={{ background: "linear-gradient(135deg, rgba(30,58,138,0.45) 0%, rgba(5,9,20,1) 55%, rgba(202,138,4,0.12) 100%)" }}>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#38BDF8]">Dashboard</div>
          <h1 className="text-3xl sm:text-4xl font-medium tracking-tight mt-2" data-testid="dashboard-welcome">
            Welcome back{me.name ? `, ${me.name.split(" ")[0]}` : ""}
          </h1>
          <div className="text-sm text-[#94A3B8] mt-1" data-testid="account-email">{me.email} · member since {since}</div>
        </div>
        <Link to="/account/setup" data-testid="dashboard-setup-guide-btn"
          className="flex items-center gap-2 text-[11px] uppercase tracking-widest px-5 py-3 rounded-lg bg-[#FBBF24] text-[#050914] font-semibold hover:scale-[1.03] transition-transform">
          <BookOpenTextIcon size={16} weight="bold" /> Step-by-step setup guide
        </Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-6">
        {tiles.map(([Icon, label, v, c, id]) => (
          <div key={id} data-testid={id} className="rounded-xl bg-[#050914]/70 border border-blue-900/40 p-4">
            <Icon size={18} weight="duotone" style={{ color: c }} />
            <div className="text-xl sm:text-2xl mt-2" style={{ color: c }}>{v}</div>
            <div className="text-[10px] uppercase tracking-widest text-[#64748B] mt-1">{label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
